"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWorkflowsCreateStatus = exports.getWorkflowsExistenceFetchStatus = exports.getWorkflowsExist = void 0;

var _actions = require("settings-ui-sdk/QuoteApproval/actions");

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var getWorkflowsExist = function getWorkflowsExist(state) {
  return state.modules.sales.products.quoteApproval;
};

exports.getWorkflowsExist = getWorkflowsExist;
var getWorkflowsExistenceFetchStatus = (0, _getRequestStatus.default)(_actions.QuoteApprovalActionTypes.FETCH_WORKFLOWS_EXISTENCE);
exports.getWorkflowsExistenceFetchStatus = getWorkflowsExistenceFetchStatus;
var getWorkflowsCreateStatus = (0, _getRequestStatus.default)(_actions.QuoteApprovalActionTypes.CREATE_WORKFLOWS);
exports.getWorkflowsCreateStatus = getWorkflowsCreateStatus;